import { render, staticRenderFns } from "./PopupShareByEmail.vue?vue&type=template&id=2adef15a&"
import script from "./PopupShareByEmail.vue?vue&type=script&lang=js&"
export * from "./PopupShareByEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports